export const ICON_SIZE = 72;
export const MESSAGE = "No more bulletins!";
export const BUTTON_TITLE = "Refresh";
export const IMAGE_PERCENTAGE = 0.4;
